import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogCustomAnnotationDropdownContentItem from './VeltCommentDialogCustomAnnotationDropdownContentItem/VeltCommentDialogCustomAnnotationDropdownContentItem';
import { transformWireframeProps } from '../../../../utils/propUtils';
;
var VeltCommentDialogCustomAnnotationDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdownContent.Item = VeltCommentDialogCustomAnnotationDropdownContentItem;
export default VeltCommentDialogCustomAnnotationDropdownContent;
